import type { HostMembershipProvider } from '@/lib/ai'
import subscriptionService from '@/services/subscription-service'
import { getAutosubscribeValueProps } from '@/lib/purchase-utils'
import { Vertical } from '@/types/verticals'
import { identity } from '@/fish/lib/ai/identity'

/**
 * Human-readable current tier. Fish only sells Basic and Elite (see
 * `HUMAN_SKUS` in `shared/lib/plans.ts` — there is no fish Premium SKU),
 * unlike the shared subscription model's other verticals.
 */
const getTier = (): string => {
  if (
    subscriptionService.isElite() ||
    subscriptionService.isEliteTrial() ||
    subscriptionService.isEmployee()
  ) {
    return 'Elite'
  }
  return 'Basic'
}

/** Fish vertical's membership state and Elite-upgrade business rule. */
export const membership: HostMembershipProvider = {
  getTier,
  // Only offer the Elite upgrade to users who don't already have Elite.
  canRecommendUpgrade: () =>
    !subscriptionService.isElite() && !subscriptionService.isEmployee(),
  getUpgradeContext: () => ({
    vertical: identity.vertical,
    productLabel: identity.productLabel,
    tier: subscriptionService.getMembershipLevel(),
    trialActive: subscriptionService.isEliteTrial(),
    benefits: getAutosubscribeValueProps(Vertical.Fish, 'ELITE') ?? [],
  }),
}
